import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import ManualPostalAddress from './ManualPostalAddress';


class AddressForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showManualAddress: false
        };
        this.widget = null
        this.full_address = React.createRef()
        this.address_line_1 = React.createRef()
        this.address_line_2 = React.createRef()
        this.suburb = React.createRef()
        this.city = React.createRef()
        this.postcode = React.createRef()

    }

    componentDidMount() {
        this.script = document.createElement('script');
        this.script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
        this.script.async = true;
        this.script.onload = this.loadWidget
        document.body.appendChild(this.script);
    }

    componentWillUnmount() {
        // widget.js can finish loading after we unmount; don't let it attach to a field that is gone
        if (this.script) {
            this.script.onload = null
            this.script = null
        }
        if (this.widget) {
            this.widget.destroy()
            this.widget = null
        }
    }

    loadWidget = () => {
        const addressInput = document.getElementById('full_address')
        if (!addressInput) {
            return
        }
        this.widget = new window.AddressFinder.Widget(
            addressInput,
            '7XRVYC8PJU43MABD6W9H',
            'NZ',
            { 'empty_content': 'Address not found. Please enter address manually.' }
        );
        this.widget.on('result:select', (fullAddress, metaData) => {
            this.props.handleChangeValue('full_address', metaData.a);
            new window.AddressFinder.NZSelectedAddress(fullAddress, metaData);
            this.props.handleChangeValue('addressLine1', metaData.address_line_1);
            this.props.handleChangeValue('addressLine2', metaData.address_line_2 || '');
            this.props.handleChangeValue('suburb', metaData.selected_suburb ? metaData.selected_suburb : metaData.selected_city);
            this.props.handleChangeValue('city', metaData.selected_city);
            this.props.handleChangeValue('postcode', metaData.postcode);
        });
    }

    handleClick = () => {
        this.setState({
            showManualAddress: true
        })
    };

    manualAddressHide = () => {
        this.setState({
            showManualAddress: false
        })
    };
    render() {
        const isAAPath = this.props.inputValues.source === 'AA' || this.props.inputValues.source === 'AA_MEMBER';
      const isVTNZPath = this.props.inputValues.source === 'VTNZ';
        return (
            <>
                {
                    this.state.showManualAddress && <>
                        <ManualPostalAddress
                            setParentManualAddressPopupShow={this.manualAddressHide}
                            parentManualAddressPopupShow={this.state.showManualAddress}
                            inputValues={this.props.inputValues}
                            handleChange={this.props.handleChange}
                            errors={this.props.errors}
                            handleChangeValue = {this.props.handleChangeValue}/>
                    </>

                }
                <div className="row" >
                    <Form.Group as={Col} md="12">
                        <Form.Label className='formHeader regularTextStyles'>Postal
                            Address</Form.Label>

                        <Form.Control
                            required
                            type="search"
                            id='full_address'
                            className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            style={{
                                background: 'white',
                                boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                borderRadius: 6,
                                overflow: 'hidden',
                                border: '1px #E5E7EB solid',
                            }}
                            placeholder="Search address here..."
                            name='full_address'
                            value={this.props.inputValues.full_address}
                            onChange={this.props.handleChange}
                            isInvalid={!!this.props.errors.full_address}
                        />


                        <Form.Control.Feedback type="invalid">
                            {this.props.errors.full_address}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Row style={{ padding: "10px", marginTop: "5px" }}>
                        <a
                            id="button-addon2"
                            onClick={this.handleClick}
                            style={{
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                            }}
                        >  Enter address manually
                        </a>
                    </Row>
                </div>

            </>
        )
    }
}

export default AddressForm;
